<script setup>
import { useReadinessStore } from '../stores';
import AppLinkCard from '../components/layouts/AppLinkCard.vue';

const readinessStore = useReadinessStore()
</script>
<template>
  <div class="mx-2">
    <div class="grid grid-cols-1 md:grid-cols-3">
      <AppLinkCard v-for="guide in readinessStore.readinessGuides" :to="`/resources/guides/${guide.id}`"
        :header="guide.title" :body="`For children under ${guide.months_marker} months old. Contains ${Object.values(guide.readiness_map).reduce((acc, curr)=> acc += curr.milestones.length, 0)} Milestones.`" :key="guide.id" />
    </div>
  </div>
</template>